// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gameAwards {
  text-align: left;
}

.gameAwardsHeading {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.05rem;
  margin: 0 0 0.55rem;
}

.gameAwardsList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.55rem;
}

.gameAward {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  background: var(--white);
  color: var(--ink);
  border-radius: var(--border-radius);
  padding: 0.55rem 0.65rem;
  border: 2px solid var(--ink-faint);
  box-shadow: var(--shadow-card);
  font-family: var(--font-body);
  text-align: left;
  box-sizing: border-box;
  min-width: 0;
}

.awardIcon {
  flex-shrink: 0;
  width: 2.15rem;
  height: 2.15rem;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: var(--ink);
}

.awardIcon svg {
  width: 1.3rem;
  height: 1.3rem;
  fill: currentColor;
}

.gameAward[data-award='mindReader'] .awardIcon {
  background: var(--sky);
}

.gameAward[data-award='biggestOutlier'] .awardIcon {
  background: var(--sky-strong);
}

.gameAward[data-award='crowdFavorite'] .awardIcon {
  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);
}

.gameAward[data-award='mostPredictable'] .awardIcon {
  background: var(--pink-soft);
}

.awardCopy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
}

.awardTitle {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.15;
}

.awardWinners {
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1.2;
}

.awardWinner.team1 {
  color: var(--team1-text);
}

.awardWinner.team2 {
  color: var(--team2-text);
}

.awardReason {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--ink-soft);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.modalItself .gameAwards {
  margin: 1rem 0 0;
}

.modalItself .gameAwards + .roundTypePicker {
  margin-top: 0.95rem;
}

@media (max-width: 600px) {
  .gameAwardsList {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/game-awards.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;EACnC,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".gameAwards {\n  text-align: left;\n}\n\n.gameAwardsHeading {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.05rem;\n  margin: 0 0 0.55rem;\n}\n\n.gameAwardsList {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.55rem;\n}\n\n.gameAward {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  background: var(--white);\n  color: var(--ink);\n  border-radius: var(--border-radius);\n  padding: 0.55rem 0.65rem;\n  border: 2px solid var(--ink-faint);\n  box-shadow: var(--shadow-card);\n  font-family: var(--font-body);\n  text-align: left;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.awardIcon {\n  flex-shrink: 0;\n  width: 2.15rem;\n  height: 2.15rem;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  color: var(--ink);\n}\n\n.awardIcon svg {\n  width: 1.3rem;\n  height: 1.3rem;\n  fill: currentColor;\n}\n\n.gameAward[data-award='mindReader'] .awardIcon {\n  background: var(--sky);\n}\n\n.gameAward[data-award='biggestOutlier'] .awardIcon {\n  background: var(--sky-strong);\n}\n\n.gameAward[data-award='crowdFavorite'] .awardIcon {\n  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);\n}\n\n.gameAward[data-award='mostPredictable'] .awardIcon {\n  background: var(--pink-soft);\n}\n\n.awardCopy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.08rem;\n}\n\n.awardTitle {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.15;\n}\n\n.awardWinners {\n  font-size: 0.92rem;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.awardWinner.team1 {\n  color: var(--team1-text);\n}\n\n.awardWinner.team2 {\n  color: var(--team2-text);\n}\n\n.awardReason {\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--ink-soft);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.modalItself .gameAwards {\n  margin: 1rem 0 0;\n}\n\n.modalItself .gameAwards + .roundTypePicker {\n  margin-top: 0.95rem;\n}\n\n@media (max-width: 600px) {\n  .gameAwardsList {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
